import * as m from "@/paraglide/messages";
import { SidebarNavItem, SiteConfig } from "@/types";
const site_url = process.env.NEXT_PUBLIC_APP_URL!;

export const siteConfig: SiteConfig = {
  name: "ARYA Crypto",
  description: m.left_calm_bison_stop(),
  url: site_url,
  ogImage: `${site_url}/og.jpg`,
  links: {
    twitter: "https://twitter.com/arya",
    github: "https://github.com/mickasmt/next-saas-stripe-starter",
  },
  mailSupport: "contact@arya.com",
};

export const footerLinks: SidebarNavItem[] = [
  {
    title: m.features(),
    items: [
      { title: m.portfolio_management_label(), href: "#portfolio" },
      { title: m.smart_allocation(), href: "#allocation" },
      { title: m.advance_trading(), href: "#trading" },
      { title: m.Pricing(), href: "/pricing" },
    ],
  },
  {
    title: m.get_started(),
    items: [
      { title: m.Pricing(), href: "/pricing" },
      { title: m.sign_in(), href: "/signin" },
      { title: m.market(), href: "/market" },
    ],
  },
  {
    title: m.tools(),
    items: [
      { title: m.cozy_slow_spider_animate(), href: "/coin-converter" },
      { title: m.early_short_lion_ask(), href: "/crypto-profit-calculator" },
    ],
  },
];
